import createSagaMiddleware from 'redux-saga';
import { rootReducer } from './reducers/rootReducer';
import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';

// Teacher Dashboard Sagas
import { handler as userSaga } from './reducers/user/saga';
import { handler as signUpSaga } from './reducers/sign_up/saga';
import { handler as classesSaga } from './reducers/classes/saga';
import { handler as studentsSaga } from './reducers/students/saga';
import { handler as studentSaga } from './reducers/student/saga';
import { handler as gradingScalesSaga } from './reducers/grading_scales/saga';
import { handler as answerSheetsSaga } from './reducers/answer_sheets/saga';
import { handler as assessmentsSaga } from './reducers/assessments/saga';
import { handler as gradingsSaga } from './reducers/grading/saga';

export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production'
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch;

// Run Teacher Dashboard Sagas
sagaMiddleware.run(userSaga);
sagaMiddleware.run(signUpSaga);
sagaMiddleware.run(classesSaga);
sagaMiddleware.run(studentsSaga);
sagaMiddleware.run(studentSaga);
sagaMiddleware.run(gradingScalesSaga);
sagaMiddleware.run(answerSheetsSaga);
sagaMiddleware.run(assessmentsSaga);
sagaMiddleware.run(gradingsSaga);
